import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetOptions} from "../../api/get-options";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import {OptionControl} from "./OptionControl";
import {SelectedOption} from "../../types/SelectedOption";
import {CustomOptionControl} from "./CustomOptionControl";

export function OptionsColumnControl({group}: { group: SelectedMaterial }) {
    const context = useCountertops();
    const options = useGetOptions(context.dealerId, group.prodQteGrpID ?? 0, context.customerZip);
    const [selectedOptions, setSelectedOptions] = useState<Map<number, SelectedOption>>(new Map<number, SelectedOption>());
    const [selectedOneProductID, setSelectedOneProductID] = useState<number | undefined>(undefined)

    useEffect(() => {
        let map = new Map<number, SelectedOption>();
        group.options.forEach(item => {
            map.set(item.productID, item);
        });

        setSelectedOptions(map);
    }, [group.options])

    useEffect(() => {
        setSelectedOneProductID(context.oneQtyMap.get(group.prodQteGrpID));
    }, [context.oneQtyMap])

    if (options.isLoading)
        return <></>

    return (
        <>
            {options.data.map(option => {
                    let selectedOption = selectedOptions.get(option.productID);
                    if (option.isCustom) {
                        if (selectedOption === undefined) {
                            return <CustomOptionControl
                                key={option.productID + "-0"}
                                prodQteGrpID={group.prodQteGrpID}
                                option={option}
                                selectedOption={undefined}
                                id={0}
                                isLast={true}
                            />
                        } else {
                            return selectedOption.customOptions.map((customOption, index, arr) => {
                                return <CustomOptionControl
                                    key={option.productID + "-" + customOption.id}
                                    prodQteGrpID={group.prodQteGrpID}
                                    option={option}
                                    selectedOption={customOption}
                                    id={customOption.id}
                                    isLast={arr.length - 1 === index}
                                />
                            })
                        }
                    }
                    return <OptionControl
                        key={option.productID}
                        option={option}
                        prodQteGrpID={group.prodQteGrpID}
                        selectedOption={selectedOption}
                        singleQty={selectedOneProductID}
                    />
                }
            )}
        </>
    );
}
